export enum MarketStatusEnum {
	preMarket = 'preMarket',
	marketOpen = 'marketOpen',
	postMarket = 'postMarket',
	marketClose = 'marketClose',
}
